import React from "react";
const InventoryIcon = ({ width, height }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.2665 0.666687L0.166504 5.61669V17.3334H1.14984V6.16669L8.2665 1.81669L15.8498 6.18335V17.3334H16.8332V5.60002L8.2665 0.666687Z" fill="#A4A4A4" />
            <path d="M11.5331 6.21667H5.46644V11.2667H2.93311V17.3333H7.99977H8.99977H14.0664V11.2667H11.5331V6.21667ZM6.44977 7.21667H7.49977V8.40001H9.48311V7.21667H10.5331V11.2667H8.99977H7.99977H6.44977V7.21667ZM3.91644 16.35V12.25H4.96644V13.4333H6.94977V12.2833H7.99977V16.3333H3.91644V16.35ZM13.0831 16.35H8.99977V12.2833H10.0498V13.4333H12.0331V12.25H13.0831V16.35Z" fill="#A4A4A4" />
        </svg>
    );
};

export default InventoryIcon;
